<template>
  <main class="main" id="main">
    <div class="top_line">
      <div class="container">
        <h1>Доставка закусок</h1>
      </div>
    </div>
    <section class="section s-seo">
      <div class="container">
        <div class="seo_box">
          <div class="bottom-wrapper">
            <div class="line"></div>
            <p style="margin-top:2%;">Вкусные закуски, закуски на праздничный стол, холодные закуски – на вашем столе с быстрой доставкой.</p>
            <p>Чем порадовать себя и своих близких на праздник или в выходной день? Простые и вкусные закуски спешат к вам на помощь. Хотите действительно насладиться вкусной едой? Заказывайте все что душе угодно на <router-link to="/">хочу-поесть.рф</router-link></p>
            <p>Заходите, выбирайте и заказывайте, чтобы не тратить время у плиты и спокойно готовиться к встрече гостей.</p>
            <p><br/><center><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/global/articles/snacks1.jpg" alt="Доставка закусок" width="700" /></center></p>
            <p style="margin-top:2%;">Дополнением к вашим горячим блюдам могут стать холодные закуски, закуска из лаваша. Закажите простые и вкусные закуски на нашем сайте всего за 2 клика.</p>
            <p>День рождение – быстрые закуски для праздничного стола; посиделки с друзьями – горячие закуски или закуски к пиву вы всегда сможете найти среди блюд на нашем сайте.</p>
            <p>Любите готовить сами? Готовьте с удовольствием и смотри рецепты простых закусок от шеф-поваров ресторанов, представленных на <router-link to="/">хочу-поесть.рф</router-link></p>
            <router-link :to="'/product/11'" tag="div">
              <button class="menu_item_btn seo">ХОЧУ ПОЕСТЬ!</button>
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'snacks'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/articles/snacks.vue